import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { AccountPage } from './pages/AccountPage';
import { ActionsPage } from './pages/ActionsPage';
import { ActivityPage } from './pages/ActivityPage';
import { FavoritesPage } from './pages/FavoritesPage';
import { HomePage } from './pages/HomePage';
import { LandingPage } from './pages/LandingPage';
import { LearnPage } from './pages/LearnPage';
import { MapPage } from './pages/MapPage';
import { StoryPage } from './pages/StoryPage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/app" element={<AppShell />}>
        <Route index element={<HomePage />} />
        <Route path="map" element={<MapPage />} />
        <Route path="activity" element={<ActivityPage />} />
        <Route path="story" element={<StoryPage />} />
        <Route path="learn" element={<LearnPage />} />
        <Route path="actions" element={<ActionsPage />} />
        <Route path="favorites" element={<FavoritesPage />} />
        <Route path="account" element={<AccountPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
